import { setSStore, getSStore, IsValid, hashQuery, getRoutePage, setRoutePage} from "@js/public/mUtils";
export const wxProAd = {
    created() {
        this.wxProAd();
    },
    methods: {
        // toRoutePage() {
        //     const routePage = getRoutePage();
        //     if (getSStore("token")) {
        //       this.toPage(routePage);
        //     } else {
        //       this.toPage("/");
        //     }
        // },
        wxProAd() {
            /**
             * 存储，确定微信用户指定的页面
             */
            const fundCode = hashQuery("fundCode") || "";
            let routePage = "/comeIn/money/all";
            if (fundCode) {
              routePage = `/productDetail?fundCode=${fundCode}`;
            }
            setRoutePage(routePage);
            // setTimeout(this.toRoutePage, 0) // 跳转目标页面在登录页面处理
        }
    }
}

export const wxProAdToTargetMx = {
    methods: {
        /**
         * 微信用户登录后重定向到指定页面
         */
        wxProAdToTarget() {
            let wxExpose = hashQuery("wxExpose") || "";
            if (wxExpose != "") {
              this.toPage(getRoutePage(), {});
              return true;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/wxProAd.js